<template>
    <div>
        <div class="w80 mb-30 sex_box">
            <!--搜素内容列表-->
           <div v-if="seachType !='专家' && seachType !='企业' ">
               <div class="container" v-for="(item,index) in  list" :key="index"  @click="onView(item)">
                 <div class="cont_image">
                   <img v-if="item.covers" :src="item.covers" alt="" />
                    <img v-else :src="(item.cover && item.cover.split(',')[0])" alt="" />
                 </div>
                  <div class="cont_info">
                      <p class="conta_title">{{item.title}}</p>
                      <div class="conta_meter" v-html="$options.filters.ellipsis(item.content)"></div>
                      <div class="conta_mer">
                      <span>{{ item.releaseDate || item.createtime }}</span>
                      <span v-if="item.readcount">浏览：{{ item.readcount}}</span>
                      <span v-if="item.visitcount">浏览：{{ item.visitcount}}</span>
                      <span v-if="item.viewerscount">浏览：{{ item.viewerscount}}</span>
                      <span v-if="item.readCount">浏览：{{ item.readCount}}</span>
                                              
                  </div>
                  </div>
               </div>
           </div>
            <!--专家-->
            <div v-else>
              <div  class="container"   v-for="(items,index) in  list" :key="index"  @click="onView(items)">
                <div class="expert_image">
                  <div class="img_box">
                      <img :src="items.headUrl" alt="">
                  </div>
                </div>
                <div  class="expert_info">
                      <p class="expert_title">{{items.name}}</p>
					            <p>{{items.job}}</p>
                      <div v-if="items.expertDes !=null" class="conta_meter" v-html="items.expertDes"></div>
					          <p style="margin-top: 10px;">{{items.address}}</p>
                </div>
              </div>
            </div>
           <!--分页-->
           <div>
               <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>
           </div>

           <div v-if="isHide == true" class="seachText">暂无匹配的数据！</div>
        </div>
    </div>
</template>
<script>
import {getActivityList,getTechnologyList,getDataList,getLessonList,getProduct,getExpertList,getCompanyList,getInterviewList} from '@/api/information'
import {industryinfoList} from '@/api/company'
import {routerGoNewpage} from "@/utils/index"
import banner from '../../common/banner'
import Pagination from '../../components/Pagination'
import { formatTime } from '../../utils'
export default {
  components:{banner,Pagination},
  data(){
    return{
     banner:{},
     seachType:'', //类型
     keyword:'', //关键字
     listQuery:{
        curPage:1,
        limit:5
     },
     total:0,//当前条数
     list:[],
     isHide:false
    }
  },
  created(){
    this.seachType = this.$route.query.type;
    this.keyword = this.$route.query.keyword;
    this.getList(this.seachType,this.keyword);
  },
  watch:{
    $route(val){
      this.seachType = val.query.type;
      this.keyword = val.query.keyword;
      this.getList(this.seachType,this.keyword);
    }
  },
  filters:{
     ellipsis(value) {
      if (!value) return "";
      if (value.length > 200) {
        return value.slice(0, 200) + "...";
      }
      return value;
    }
  },
  methods:{
    pageChange(data){
       this.listQuery['curPage'] = data.page;
       this.listQuery['limit'] = data.limit;
       switch(this.seachType){
         case '产品':
            this.getProduct(this.keyword)
          break;
         case '资讯':
            this.getInformation(this.keyword)
         break;
         case '技术':
            this.getTechnology(this.keyword)
         break;
         case '资料':
            this.getMeans(this.keyword)
         break;
         case '供需':
            this.getSupply(this.keyword)
         break;
         case '课堂':
            this.getClassroom(this.keyword)
         break;
         case '专家':
            this.getExpert(this.keyword)
         break;
         case '活动':
            this.getActivity(this.keyword)
         break;
		case '企业':
		  this.getEnterprise(this.keyword)
		break;
          default:
         break;
       }
    },
    //查询列表
    getProduct(data){   // 查询产品
      getProduct({
        ...this.listQuery,
        keyword:data
      }).then((res)=>{
        if(res.code == 0){
          this.list = res.page.list;
          this.list = res.page.list
          this.total = res.page.totalCount;
		      this.list.length == 0 ? this.isHide = true : this.isHide = false;
        }
      }).catch((err)=>{})
    },
    getInformation(data){ //资讯
      industryinfoList({
        ...this.listQuery,
        keyword:data
      }).then((res)=>{
        if(res.code == 0){
          this.list = res.page.list;
          this.total = res.page.totalCount;
		      this.list.length == 0 ? this.isHide = true : this.isHide = false;
        }
      }).catch((err)=>{})
    },
    getTechnology(data){ //技术
     getTechnologyList({
       ...this.listQuery,
       keyword:data
     }).then((res)=>{
        if(res.code == 0){
          this.list = res.page.list;
          this.total = res.page.totalCount;
		      this.list.length == 0 ? this.isHide = true : this.isHide = false;
        }
     }).catch((err)=>{})
    },
    getMeans(data){ //资料
       getDataList({
         ...this.listQuery,
         keyword:data
       }).then((res)=>{
         if(res.code ==0){
           this.list = res.page.list
           this.total = res.page.totalCount;
	    	   this.list.length == 0 ? this.isHide = true : this.isHide = false;
         }
       }).catch((err)=>{})
    },
    getSupply(data){ //供需
      getProduct({
        ...this.listQuery,
        keyword:data
      }).then((res)=>{
        if(res.code == 0){
          this.list = res.page.list;
          this.list = res.page.list
          this.total = res.page.totalCount;
		      this.list.length == 0 ? this.isHide = true : this.isHide = false;
        }
      }).catch((err)=>{})
    },
    getClassroom(data){ //课堂
      getLessonList({
        ...this.listQuery,
        keyword:data
      }).then((res)=>{
        if(res.code == 0){
           this.list = res.page.list
           this.total = res.page.totalCount;
		       this.list.length == 0 ? this.isHide = true : this.isHide = false;
        }
      }).catch((err)=>{})
    },

    // 企业专访
    getInterView(data){
      getInterviewList({
        ...this.listQuery,
        title: data
      }).then((res)=>{
         if(res.code == 0){
           this.list = res.page.list
           this.total = res.page.totalCount;
		       this.list.length == 0 ? this.isHide = true : this.isHide = false;
        }
      })
    },

    getExpert(data){ //专家列表
      getExpertList({
        ...this.listQuery,
        keyword:data
      }).then((res)=>{
        if(res.code == 0){
          this.list = res.data.list;
          this.total = res.data.list.length;
		      this.list.length == 0 ? this.isHide = true : this.isHide = false;
        }
      }).catch((err)=>{})
    },
    getActivity(data){ //活动列表
      getActivityList({
       ...this.listQuery,
       keyword:data
      }).then((res)=>{
          if(res.code == 0){
            this.list = res.page.list;
            this.total = res.page.totalCount;
	      	this.list.length == 0 ? this.isHide = true : this.isHide = false;
          }
      }).catch((err)=>{})
    },
	//查询企业
	getEnterprise(data){
		getCompanyList({
		 ...this.listQuery,
		 keyword:data
		}).then((res)=>{
		  if(res.code == 0){
			 console.log(res.data)
			 this.list = res.data.list;
			 this.total = res.data.totalCount;
			 this.list.length == 0 ? this.isHide = true : this.isHide = false;
		  }
		})
	},

    getList(seachType,keyword){
       switch(seachType){
         case '产品':
            this.getProduct(keyword)
          break;
         case '资讯':
           this.getInformation(keyword)
         break;
         case '技术':
           this.getTechnology(keyword)
         break;
         case '资料':
           this.getMeans(keyword)
         break;
         case '供需':
           this.getSupply(keyword)
         break;
         case '课堂':
           this.getClassroom(keyword)
         break;
         case '专家':
           this.getExpert(keyword)
         break;
         case '活动':
           this.getActivity(keyword)
         break;
		 case '企业':
		   this.getEnterprise(keyword)
		 break;
       }
    },
    //查询详情
    onView(item){
     switch(this.seachType){
        case '产品':
           routerGoNewpage('/supply_detail',{id:item.id})
          break;
         case '资讯':
           routerGoNewpage('/info_detail',{id:item.id})
         break;
         case '技术':
           routerGoNewpage('/technology_detail',{id:item.id})
         break;
         case '资料':
            routerGoNewpage('/data_detail',{id:item.id})
         break;
         case '供需':
           routerGoNewpage('/supply_detail',{id:item.id})
         break;
         case '课堂':
           routerGoNewpage('/environmental_college_detail',{id:item.id})
         break;
         case '专家':
            routerGoNewpage('/expert_detail',{id:item.userId})
         break;
         case '活动':
            routerGoNewpage('/activity_detail',{id:item.id})
         break;
		    case '企业':
		     routerGoNewpage('/corporate_detail',{id:item.userId})
		      break;
         default:
          break;
     }
    }
  },
}
</script>
<style scoped ="scoped">
.mb-30{
  margin-bottom: 30px;
}
.sex_box{
  margin-top: 30px;
}
.container{
    width: 100%;
    transition: all 0.5s;
    cursor: pointer;
    height: 175px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f8f8f8;
    padding: 15px;
    border-radius: 5px;
}
.container:hover{
   box-shadow: 0 0 20px #ddd;
}
.conta_title{
   font-size: 18px;
   font-family: Microsoft YaHei;
   font-weight: 400;
   color: #000000;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.conta_meter{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    margin-top: 10px;
    height: 60px;
}
.conta_meter >>>p{
  margin-top: 10px;
}
.seachText{
    font-size: 16px;
    color: #666666;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 87px;
}
.cont_image{
  width: 280px;
  height: 100%;
  overflow: hidden
}
.cont_image img{
   width: 100%;
   height: 100%;
   object-fit: cover;
   transition: all 0.5s;
}
.cont_image img:hover{
  transform: scale(1.2);
}
.cont_info{
  display: flex;
  flex-direction: column;
  width: 70%;
  height: 100%;
  margin-left: 15px;
}
.conta_mer{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
}
.conta_mer span:nth-of-type(2){
   margin: 0 40px;
}

/***专家列表 */
.expert_image{
  width: 150px;
  height: 150px;
  margin-left: 20px;
  overflow: hidden;
}
.img_box{
  width: 145px;
  height: 145px;
  border-radius: 50%;
  overflow: hidden;
  margin-top: 1px;
}
.img_box img{
  width: 100%;
  vertical-align: middle;
  /* height: 100%; */
}
.expert_info{
  display: flex;
  flex-direction: column;
  width:81%;
  height: 100%;
  margin-left: 15px;
}
.expert_title{
   font-size: 24px;
   font-family: Microsoft YaHei;
   font-weight: 400;
   color: #000000;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/other/searchIndex.vue